<script>
import { mapGetters } from "vuex";
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from "mdb-vue-ui-kit";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from "/src/config/foresters-financial";

export default {
  name: "NextPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
  },

  data() {
    return {
      clientConfig,
    };
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "analyticsPageNames",
      "activeTab",
      "lastActiveTab",
      "typeOfBond",
    ]),
  },

  methods: {
    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ffApp");

      this.$triggerIframeAnalytics({
        event: "calculator",
        calculator_name: "Investment Forecaster",
        calculator_section: this.analyticsPageNames[tabNum],
        calculator_step: tabNum < this.lastActiveTab ? "Back" : "Continue",
      });

      if (this.debugMode)
        console.log(
          "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
          this.analyticsPageNames[tabNum] + 
          ", calculator_step: " + (tabNum < this.lastActiveTab ? "Back" : "Continue")
        );


      // Pretend this is an onload of the next page
      setTimeout(() => {
        this.$triggerIframeAnalytics({
          event: "calculator",
          calculator_name: "Investment Forecaster",
          calculator_section: this.analyticsPageNames[this.activeTab],
          calculator_step: "Start",
        });

        if (this.debugMode)
          console.log(
            "GTM Event: calculator_name: Investment Forecaster, calculator_section: " + 
            this.analyticsPageNames[this.activeTab] + 
            ", calculator_step: Start"
          );
      }, 100);
    },
  },

  mounted() {},
};
</script>

<template>
  <MDBContainer fluid class="p-0">
    <div class="sub-section-header next p-0 mt-0 col-md-11 col-lg-10 mx-auto">
      <div v-html="clientConfig.content.whatsnext.header"></div>
      <!-- <div v-html="clientConfig.content.whatsnext.content"></div> -->

      <MDBRow class="extra-top-padding mx-0">
        <MDBCol sm="12" md="6" class="mx-auto">
          <div class="card column-gap">
            <div class="card-body">
              <h4 class="card-title">
                {{ typeOfBond === 1 ? "Investment" : "Funeral" }} Bonds
              </h4>

              <p class="card-text">
                <span v-if="typeOfBond === 1">
                  A better way to grow, protect and transfer your wealth.
                </span>
                <span v-else>
                  Give yourself peace of mind and protect loved ones from inheriting funeral costs.
                </span>
              </p>

              <a
                class="btn btn-primary next-steps"
                href="https://forestersfinancial.com.au/investment/"
                aria-label="Learn more"
                target="_blank"
                v-if="typeOfBond === 1"
              >
                Learn more
            </a>

              <a
                class="btn btn-primary next-steps"
                href="https://forestersfinancial.com.au/funeral/"
                aria-label="Learn more"
                target="_blank"
                v-else
              >
                Learn more
          </a>
            </div>
          </div>
        </MDBCol>
        <MDBCol sm="12" md="6" class="mx-auto">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Get in touch
              </h4>

              <p class="card-text">
                Speak to a bond specialist today.
              </p>

              <a
                class="btn btn-primary next-steps"
                href="https://forestersfinancial.com.au/contact-us/"
                aria-label="Contact us"
                target="_blank"
              >
                Contact us
            </a>
            </div>
          </div>
        </MDBCol>
      </MDBRow>
    </div>
  </MDBContainer>

  <MDBContainer fluid class="px-md-5">
    <MDBRow class="px-2">
      <MDBCol md="11" class="main-nav-wrapper">
        <MDBRow>
          <MDBCol md="11" class="mt-3 mb-5 text-center text-sm-start">
            <MDBBtn
              color="primary"
              class="btn btn-primary next-steps"
              @click="clickToTab(4)"
              aria-label="Back button"
            >
              Back
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
